import React, { useState, useRef, useEffect } from 'react';
import './MobileInputBar.css';

const PLACEHOLDER_EXAMPLES = [
  "Who should I follow up with?",
  "Tell me about David...",
  "Who wants to get dinner?",
  "Met with Sarah yesterday...",
  "Who hasn't given in a while?",
  "What's the status with the board?",
  "Who mentioned their kids?",
  "Any birthdays coming up?"
];

function MobileInputBar({ onSubmit, isSubmitting, compact, onAddPerson }) {
  const [text, setText] = useState('');
  const [placeholderIndex, setPlaceholderIndex] = useState(0);
  const textareaRef = useRef(null);

  // Cycle through placeholder examples
  useEffect(() => {
    const interval = setInterval(() => {
      setPlaceholderIndex(prev => (prev + 1) % PLACEHOLDER_EXAMPLES.length);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  // Auto-resize textarea
  const handleTextChange = (e) => {
    setText(e.target.value);
    // Reset height to auto to get correct scrollHeight
    e.target.style.height = 'auto';
    e.target.style.height = Math.min(e.target.scrollHeight, 120) + 'px';
  };

  // Handle submit
  const handleSubmit = () => {
    if (!text.trim() || isSubmitting) return;

    onSubmit(text.trim());
    setText('');

    // Reset textarea height
    if (textareaRef.current) {
      textareaRef.current.style.height = 'auto';
    }
  };

  // Handle keyboard submit (Enter without Shift)
  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSubmit();
    }
  };

  const hasText = text.trim().length > 0;

  return (
    <div className={`mobile-input-bar ${isSubmitting ? 'loading' : ''} ${compact ? 'compact' : ''}`}>
      <div className="input-bar-container">
        {onAddPerson && (
          <button
            type="button"
            className="input-bar-add-person"
            onClick={() => onAddPerson()}
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
              <circle cx="8.5" cy="7" r="4"/>
              <line x1="20" y1="8" x2="20" y2="14"/>
              <line x1="23" y1="11" x2="17" y2="11"/>
            </svg>
          </button>
        )}
        <textarea
          ref={textareaRef}
          className="input-bar-textarea"
          value={text}
          onChange={handleTextChange}
          onKeyDown={handleKeyDown}
          placeholder={PLACEHOLDER_EXAMPLES[placeholderIndex]}
          rows={1}
          disabled={isSubmitting}
        />
        <button
          className={`input-bar-send ${hasText ? 'active' : ''}`}
          onClick={handleSubmit}
          disabled={!hasText || isSubmitting}
        >
          <span>↑</span>
        </button>
      </div>
    </div>
  );
}

export default MobileInputBar;
